<template>
	<custom-p-modal
		:value='isOpen'
		@input='onModalToggle'
		:contentStyle='{ overflow: "visible" }'
		title='Загрузка файлов на сервер'
	>

		<p-file-upload
			name='demo[]'
			:url='upload_tax_url'
			multiple
			accept='.pdf'

			upload-label='Загрузить'
			cancel-label='Очистить'
			choose-label='Выбрать файлы'

			custom-upload
			@uploader='uploadFiles'
		>
			<template #empty>
				Перетащите файлы для загрузки сюда
			</template>
		</p-file-upload>

	</custom-p-modal>
</template>

<script>
	const ROOT_API = process.env.VUE_APP_ROOT_API;
	const TAX_UPLOAD = ROOT_API + 'load_file/tax_upload.php';

	export default {
		name: 'TaxUploadModal',

		model: {
			prop: 'isOpen'
		},

		props: [ 'isOpen', 'currentLpo' ],

		computed: {
			upload_tax_url() {
				return TAX_UPLOAD;
			}
		},

		methods: {
			onModalToggle(event) {
				this.$emit('input', event);
			},

			uploadFiles(files) {
				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);

				for (let file of files.files) {
					form.append('files[]', file);
				}

				fetch(TAX_UPLOAD, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.$emit('uploaded');
				});
			}
		}
	};
</script>

<style scoped>
</style>